import { Box, BoxProps } from '@components/gassan-ui/Layout/Box'
import { CleanButton, Container, Icon, OldHeading, breakpoints } from '@gassan-ui'
import shouldForwardProp from '@styled-system/should-forward-prop'
import { FC, useState } from 'react'
import styled from 'styled-components'

const Button = styled(CleanButton)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  @media screen and (min-width: ${breakpoints.medium}) {
    pointer-events: none;
    svg {
      display: none;
    }
  }
`

const Content = styled(Box).withConfig({
  shouldForwardProp,
})<{ isOpen: boolean }>`
  display: ${(p) => (p.isOpen ? 'grid' : 'none')};
  @media screen and (min-width: ${breakpoints.medium}) {
    display: grid;
  }
`

type Props = BoxProps & {
  label: string
  defaultIsOpen?: boolean
}

const StoresContainer: FC<Props> = ({ defaultIsOpen, label, children, ...rest }) => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen)
  return (
    <Box {...rest}>
      <Container>
        <Button onClick={() => setIsOpen(!isOpen)}>
          <OldHeading as="h2" variant="h1" mb={0}>
            {label}
          </OldHeading>
          <Icon icon={isOpen ? 'chevron-up' : 'chevron-down'}></Icon>
        </Button>
        <Content
          isOpen={isOpen}
          display="grid"
          gridTemplateColumns={{ _: '1fr', medium: '1fr 1fr', large: '1fr 1fr 1fr' }}
          gridColumnGap={{ medium: '1.5rem', large: '2rem' }}
          gridRowGap={{ _: '2.5rem', medium: '3rem', large: '4rem' }}
          pt={{ _: '1.5rem', medium: '2rem', large: '2.5rem' }}
        >
          {children}
        </Content>
      </Container>
    </Box>
  )
}

export default StoresContainer
